
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './IAppForm'
import { ApplicationModule, DataModule } from '@/store'

	@Component({
	  name: 'MaritalStatus'
	})
export default class MaritalStatus extends Vue implements IAppForm {
  // #region Props

		@Prop() wizardIndex!: number;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		accordionOpen = false;
		showError = false;

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }
		  this.$emit('submit', this.wizardIndex)
		}

		previous () {
		  this.$emit('previous')
		  this.value.maritalStatus.id = ApplicationModule.formCopy.maritalStatus.id
		}

		validate () {
		  this.showError = false

		  if (this.value.maritalStatus.id === 0) {
		    this.showError = true
		    return false
		  }

		  return true
		}

		setValue (val: number) {
		  this.showError = false
		  this.value.maritalStatus.id = val

		  this.accordionOpen = !!(this.idval !== undefined && this.idval !== 24)

		  if (val !== 0) {
		    setTimeout(() => { this.submit() }, 500)
		  }
		}

		// #endregion

		// #region Computed

		get maritalStatusName () {
		  const obj = DataModule.maritalStatuses.find(v => v.value === this.value.maritalStatus.id)

		  return this.value.maritalStatus.id && this.value.maritalStatus.id > 0 && obj ? obj.label : ''
		}

		get shortArray () {
		  return [
		    { label: 'Single', value: 24 },
		    { label: 'Other', value: 0 }
		  ]
		}

		get fullArray () {
		  return [
		    { label: 'Married', value: 23 },
		    { label: 'Cohabiting', value: 25 },
		    { label: 'Divorced', value: 26 },
		    { label: 'Separated', value: 28 },
		    { label: 'Widowed', value: 29 },
		    { label: 'Civil partnership', value: 30 }
		  ]
		}

		get idval () {
		  return this.value.maritalStatus.id
		}

		@Watch('idval', { deep: true, immediate: true })
		async clearError () {
		  this.accordionOpen = !!(this.idval !== undefined && this.idval !== 24)

		  if (this.value.maritalStatus.id && this.value.maritalStatus.id > 0) {
		    this.showError = false
		  }
		}

  // #endregion
}
